import { useMemo } from 'react';
import { getConfig, getConfigValue } from '../lib/config';

/**
 * Custom hook for accessing configuration values
 * Provides a clean React interface to config.json
 * 
 * @param {string} path - Optional dot-notation path to specific config value
 * @returns {any} Configuration value or entire config object
 */
export const useConfig = (path = null) => {
  const config = useMemo(() => {
    if (path) {
      return getConfigValue(path);
    }
    return getConfig();
  }, [path]);
  
  return config;
};

/**
 * Hook for audio-specific configuration
 */
export const useAudioConfig = () => {
  return useConfig('audio');
};

/**
 * Hook for visual configuration
 */
export const useVisualConfig = () => {
  return useConfig('visual');
};

/**
 * Hook for typography configuration  
 */
export const useTypographyConfig = () => {
  return useConfig('typography');
};

export default useConfig;